import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { Contrato } from '../domain/contrato.model';

export class ContratoSerializer extends DomainSerializer<Contrato> {}
